/*
创建者 魏强(2018.1.30)
农特生鲜 banner
*/
<template>
  <div class="wrapper">
    <div
      class="focus-warp"
      style="position:relative;"
    >
      <div
        class="swipe-wrap"
        id="swiper"
      >
        <div
          class="swipe"
          id="swiper-container"
        >
          <Carousel
            v-model="value"
            :autoplay="setting.autoplay"
            :autoplay-speed="setting.autoplaySpeed"
            :dots="setting.dots"
            :radius-dot="setting.radiusDot"
            :trigger="setting.trigger"
            :arrow="setting.arrow"
            :height="480"
          >
            <CarouselItem
              v-for="item in list "
              :key="item.key"
            >
              <router-link :to="item.to">
                <img
                  class="img-item"
                  :src="item.atturl"
                />
              </router-link>
            </CarouselItem>
          </Carousel>
        </div>
      </div>
      <banner-right-flow></banner-right-flow>
    </div>
  </div>
</template>
<script>
import { pcTopAdv } from "api/home";
import { parseAdvList } from "utils/tool";
import bannerRightFlow from "./banner-right-flow";
export default {
  components: {
    bannerRightFlow,
  },
  data() {
    return {
      list: [],
      value: 0,
      setting: {
        autoplay: true,
        autoplaySpeed: 40000,
        dots: "inside",
        radiusDot: true,
        trigger: "hover",
        arrow: "never",
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      pcTopAdv(40).then((json) => {
        if (json.resCode == 1) {
          let data = json.data;
          this.list = parseAdvList(data.advInfoList[0].advList);
        }
      });
    },
  },
};
</script>
<style scoped>
.img-item {
  height: 480px;
  width: 1190px;
}
</style>


// WEBPACK FOOTER //
// banner.vue?27f252b2